import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator';
import { mainStore } from '../_store/main';
import OnScreenItem from './OnScreenItem';

const g:any = window[ENV.projectName] = window[ENV.projectName] || {};

import OnScreenImg from './OnScreenImg';


@Component
export default class AboutMemberItem extends OnScreenImg {
  mounted() {
  }
}